import { render } from "./DemographicBasketRule.vue?vue&type=template&id=4aed8471&scoped=true"
import script from "./DemographicBasketRule.vue?vue&type=script&lang=js"
export * from "./DemographicBasketRule.vue?vue&type=script&lang=js"

import "./DemographicBasketRule.vue?vue&type=style&index=0&id=4aed8471&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aed8471"]])

export default __exports__